import { LandsbankinnIcon24, Row, LTMLogoIcon100 } from '@landsbankinn/ui-kit';
import { useBrand } from 'src/hooks/useBrand';

export const HEIGHT = '90';
export const MAX_WIDTH = '780';

export function SimpleHeader() {
  const brand = useBrand();
  return (
    <Row
      as="header"
      height={HEIGHT}
      borderBottom="thin"
      marginHorizontal="auto"
      paddingVertical="36"
      width="100%"
      mainAxisAlignment="center"
    >
      <Row
        paddingHorizontal="20"
        grow="1"
        maxWidth={MAX_WIDTH}
        mainAxisAlignment="start"
        crossAxisAlignment="center"
      >
        {brand === 'TM' ? (
          <LTMLogoIcon100 height="50" width="90" />
        ) : (
          <LandsbankinnIcon24 size="36" color="blue font" />
        )}
      </Row>
    </Row>
  );
}
